import { adminapi, api } from "./api";

export const getAddressApi = (params) => {
  return api.get(`/customer/addressById?cmr_id=${params}`);
};
export const productListApi = (params) => {
  return api.get(`/product/get?field=${params?.field}&value=${params?.value}`);
};
export const productDetailsApi = (params) => {
  return api.get(
    `/product/getItemAvailableStockAndUOM?item_id=${params?.item_id}&item_uom=${params?.item_uom}`
  );
};
export const productBatchDetailsApi = (params) => {
  return api.get(
    `/product/itemBatch/getBatchNumberItemId?item_id=${params?.item_id}`
  );
};
export const phoneListApi = (params) => {
  return api.get(
    `/customer/getByPhoneNumber?cmr_phone_number=${params?.phone}`
  );
};
var headers = new Headers();
headers.append(
  "X-CSCAPI-KEY",
  "VTU5Q2RWNkM1Z1BkbXZCa2JnTFp1MXBXN3htRVNkYkF3Zk90QmprTQ=="
);
var requestOptions = {
  headers: headers,
  redirect: "follow",
};
export const stateListApi = () => {
  return fetch(
    `https://api.countrystatecity.in/v1/countries/IN/states`,
    requestOptions
  );
};
export const doctorListApi = () => {
  return api.get(`/doctor/get`);
};
export const storeIdApi = () => {
  return api.get(`/storeId/get`);
};

export const paymentMethodListApi = () => {
  return api.get(`/paymentsModes/get`);
};
export const tableAlertApi = (params) => {
  return api.get(
    `/notification/get-table-name-by-transaction-type?transaction_type=${params?.table}`
  );
};
export const columnAlertApi = (params) => {
  return api.get(
    `/notification/get-column-names-by-table-names?tables=${params?.tables}`
  );
};
export const allUsersListApi = () => {
  return api.get("notification/get-role-and-user-list");
};

export const catListApi = () => {
  return api.get(`/settings/itemgcategory/dropdown`);
};
export const uomListApi = () => {
  return api.get(`/settings/uoms`);
};
export const priceListApi = () => {
  return api.get(`/discount/pricelist/get`);
};
export const itemGroupListApi = () => {
  return api.get(`/settings/itemgroup/dropdown`);
};
export const itemTypeListApi = () => {
  return api.get(`/settings/itemgtype/dropdown`);
};
export const taxCatListApi = () => {
  return api.get(`/settings/tax-combination-item/dropdown`);
};
export const manufacturesListApi = () => {
  return api.get(`/settings/manufacturers`);
};
export const shippingTypeListApi = () => {
  return api.get(`/settings/shipping-types`);
};
export const sectorListApi = () => {
  return api.get(`/sector/get`);
};
export const schListApi = () => {
  return api.get(`/productScheduleList/get`);
};
export const vendorListApi = () => {
  return api.get(`/preferred_vendor/get`);
};
export const valListApi = () => {
  return api.get(`/valuationMethod/get`);
};

export const uomGroupListApi = (params) => {
  return api.get(`/settings/uom-groups`, JSON.stringify(params));
};
export const uomGroupFindOneApi = (params) => {
  return api.get(`/settings/uom-group-items?group_id=${params}`);
};
export const imageUploadApi = (params) => {
  return api.post(`/image/upload`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const adminRolesApi = () => {
  return api.get(`/user/permission/get`);
};
export const adminRolesModApi = () => {
  return api.get(`/template/get-customizatio-by-role`);
};
export const departmentListApi = () => {
  return api.get(`/department/get`);
};
export const RolesListApi = () => {
  return api.get(`/roles/get`);
};

export const attachedRolesDepartmentListApi = (params) => {
  console.log("params", params);
  if (params) {
    return api.post(`/list-attached-roles-from-department?search=${params}`);
  } else return api.post(`/list-attached-roles-from-department?search=`);
};

export const docListApi = () => {
  return api.get(`/get/documentType`);
};
export const UsersListApi = (data) => {
  return api.get(`/user/getUsers?role=${data}`);
};

export const cusTypeListApi = () => {
  return api.get(`/api/cpos/customerType/get`);
};
export const acqSrcListApi = () => {
  return api.get(`/api/cpos/acquiredSource/get`);
};
export const buisnessTypeListApi = () => {
  return api.get(`/api/cpos/bussinessType/get`);
};
export const bnkNameListApi = () => {
  return api.get(`/api/cpos/bank/list`);
};
export const disCusListApi = () => {
  return api.get(`/customerGroup/get`);
};
export const disCusGrpListApi = () => {
  return api.get(`/settings/partyGroup/list`);
};
export const disCusCatListApi = () => {
  return api.get(`/partyCategory/list`);
};
export const disCusTypeListApi = () => {
  return api.get(`/settings/partyType/list`);
};

export const customerListApi = (params) => {
  // return api.get(`/vendor/get?field=${params?.field}&value=${params?.value}`);
  return api.get(
    `/customer/getByType?field=${params?.field}&value=${params?.value}&sortfield=is_vendor_cmr&sortValue=${params?.isVendor}`
  );
};
export const pincodeListApi = (params) => {
  return fetch(`https://api.postalpincode.in/pincode/${parseInt(params)}`);
};
export const binLocationListApi = () => {
  return api.get(`/warehouse/getAllBinLocation`);
};
export const wareHouseListApi = () => {
  return api.get(`/stock/transfer/warehouselist`);
};

export const newWareHouseListApi = () => {
  return api.get(`/warehouse/getAllWarehouses`);
};

export const storeListApi = () => {
  return api.get(`/storelist/getdropDown`);
};
export const transactionShareApi = (params) => {
  return api.post(`/order/invoice/share`, JSON.stringify(params));
};

export const transactionPrintApi = (params) => {
  if (params?.transaction_type === "Billing") {
    return api.get(`/order/getOrderByIdAsPdf?sot_id=${params?.transaction_id}`);
  } else if (params?.transaction_type === "invoice_credit_note") {
    return api.get(
      `/order/invoice_credit_note/getOrderByIdHTML?icn_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "sales_order") {
    return api.get(`/saleorder/getByIdHTML?sott_id=${params?.transaction_id}`);
  } else if (params?.transaction_type === "sales_delivery") {
    return api.get(
      `/saleorder/delivery/getOrderByIdHTML?sodtt_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "sales_invoice") {
    return api.get(
      `/saleorder/invoice/getByIdHTML?soit_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "sales_credit_note") {
    return api.get(
      `/saleorder/creditNote/getByIdHTML?sct_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "sales_return") {
    return api.get(
      `/saleorder/returnInvoice/getByIdHTML?srt_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "purchase_order") {
    return api.get(
      `/purchaseorder/getOrderByIdHTML?pot_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "goods_receipt_note") {
    return api.get(
      `/purchaseorder/gop/getOrderByIdHTML?gort_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "purchase_invoice") {
    return api.get(
      `/purchaseorder/invoice/getOrderByIdHTML?poit_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "purchase_credit_note") {
    return api.get(
      `/purchaseorder/creditNote/getOrderByIdHTML?pct_id=${params?.transaction_id}`
    );
  } else if (params?.transaction_type === "purchase_return") {
    return api.get(
      `/purchaseorder/return/getOrderByIdHTML?prt_id=${params?.transaction_id}`
    );
  }
};

export const storeCityListApi = () => {
  return adminapi.get(`/storelist/cityDropdown`);
};
export const storeStateListApi = () => {
  return adminapi.get(`/storelist/stateDropdown`);
};
export const storeDistrictListApi = () => {
  return adminapi.get(`/storelist/districtDropdown`);
};
export const storeSearchApi = () => {
  return adminapi.get(`/storelist/storeSearch`);
};
export const storesItemApi = (params) => {
  return adminapi.get(`/storelist/otherStoreStockLevel/itembyId?item_id=${params?.item_id}&state=${params?.state}&district=${params?.district}&city=${params?.city}
  `);
};
